module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    attrs: {
      "id": "studyIntervalButtons"
    }
  }, [_vm._c('div', {
    staticClass: "btn-group btn-group-justified"
  }, [_vm._c('a', {
    staticClass: "btn btn-repeat btn-default btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setMicroNoteNextStudy(0)
      }
    }
  }, [_vm._c('span', [_vm._v("Repeat - ")]), _vm._v("Now")]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn btn-hard btn-default btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setMicroNoteNextStudy(24)
      }
    }
  }, [_vm._c('span', [_vm._v("Hard - ")]), _vm._v("1 Day")]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn btn-medium btn-default btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setMicroNoteNextStudy(72)
      }
    }
  }, [_vm._c('span', [_vm._v("Good - ")]), _vm._v("3 Days")]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn btn-easy btn-default btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setMicroNoteNextStudy(168)
      }
    }
  }, [_vm._c('span', [_vm._v("Easy - ")]), _vm._v("1 Week")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23696e35!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/StudyIntervalButtons.vue
// module id = 634
// module chunks = 1